export const parseMarkDownLinks = (text) => {
  return text.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank">$1</a>');
}